<template>
	<footer class="footer">
		<div class="container footer__container">
			<div class="footer__form-wrapper" id="contact-form">
				<ContactForm />
			</div>

			<div class="footer__info-wrapper">
				<h2 class="title title--style5 footer__title">
					{{ $t('landing.footer.title') }}
				</h2>

				<div class="footer__info">
					<p v-html="$t(infoContent ?? '')"></p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import ContactForm from '@/components/landing/Forms/ContactForm.vue'
import { getStoredRegion } from '@/helpers/defineRegion.js'

export default {
	name: 'AppFooter',
	components: { ContactForm },
	data() {
		return {
			infoContent: null
		}
	},
	mounted() {
		const currentRegion = getStoredRegion()

		switch (currentRegion) {
			case 'sng':
				this.infoContent = 'landing.footer.sng_region_info'
				break
			default:
				this.infoContent = 'landing.footer.other_region_info'
		}
	}
}
</script>
